import styled from "styled-components";
import { theme } from "../../styles/theme";

export const UpperContainer = styled.div`
  height: auto;
  padding: 25px 205px 25px 40px;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  text-align: center;
  background-size: cover;
  border-bottom: 2px solid ${theme.colors.gray.Cinza_12};
  background: ${props => props.background || theme.colors.white.Branco};

  .iconsLogo {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 50px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .logo{
      width: 200px;
      position: absolute;
      top: 20px;
      left: 20px;
      img{
          width: 150px;
      }
    }

    .faq{
      position: absolute;
      top: 25px;
      right: 50px;
      a{
          text-decoration: none;
          font-family: Lato;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #dfe4eb;
      }
    }
  }
  
  @media only screen and (max-width: 979px) {
    padding: 25px 205px 25px 40px;
  }

  @media only screen and (max-width: 780px) {
    height: auto;
  }

  @media only screen and (max-width: 760px) {
    padding: ${props => props.search ? '32px 16px 32px;' : '32px 16px 32px'};
  }
`;

export const ContainerNew = styled.div`
  width: 100%;
  text-align: ${props => props.align || "center"};
  display: flex;
  flex-direction: row;
  align-items: ${props => props.search && "center"};
  justify-content: ${props => props.search || (props.isTest == true || props.isPrePago == true) ? 'flex-start' : 'flex-start'};
  margin: 0;

  gap: 16px;
  align-items: center;

  small {
    padding: 10px;
    font-size: 14px;
    margin-top: 20px;
    color: #808080;

    a{
      text-decoration: none;
      cursor: pointer;
      font-weight: 700;
      color: #589bff;

      &:hover {
      }

    }
  }

  @media only screen and (max-width: 979px) {
    /* flex-direction: column; */
    /* margin-top: 30px; */
    margin-top: 0;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;

    gap: 8px;
    margin-top: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
    justify-content: space-between;
    /* margin-top: ${props => props.search ? '80px' : '30px'}; */
  }

  /* @media only screen and (max-width: 540px) {
    margin-top: ${props => props.hideFilter == false && props.search ? "120px" : props.search && '100px'};
    margin-top: 0;
    width: 90%;
  } */

    @media only screen and (max-width: 760px) {
      flex-direction: row;
      margin-top: ${props => props.padding || '0'};
    }

    @media (max-width: 479px) {
      margin-top: 0;
    }
`;

export const SearchField = styled.div`
  margin-left: 10px;
  height: 37px;
  border-radius: 25px;
  box-shadow: 0px 0px 10px -1px black;
  width: 300px;
  color: white;
  background-color: #fff;
  border: none;
  padding: 0px 2px;
  display: flex;
  justify-content: space-around;
  margin-bottom: 0px;
  
  @media only screen and (max-width: 900px){
    margin-left: 0;
    width: 327px;
    border-radius: 40px;
  }

  @media only screen and (max-width: 540px){
    margin-bottom: 20px;
    border-radius: 20px;
  }

  @media only screen and (max-width: 340px){
    width: 100%;
  }
`;

export const TitleGroup = styled.div`
  width: auto;
  height: auto;
  min-width: 0;

  gap: 8px;
  display: flex;
  align-items: center;
`;

export const Titulo = styled.h1`
  text-align: ${props => (props.search && props.isMobile == false ? 'left' : 'center')};
  color: ${theme.colors.gray.Cinza_2};
  font-weight: 800;
  font-size: 28px;
  margin-right: 0;
  margin-bottom: 0px;

  i{
    margin-left: 4px;
  }

  >svg{
    margin-left: 4px;
  }
  
  @media only screen and (max-width: 900px){
    font-size: 18px;
  }
  @media only screen and (max-width: 768px) {
    margin-bottom: 0px;
    font-size: 18px;
    /* width: 100%; */
    /* margin-top: ${props => props.hideFilter == false && props.search ? '40px' : props.search && props.estados ? '60px' : props.search && '45px'}; */
    margin-top: 0;
  }
  @media only screen and (max-width: 540px) {
    margin-right: 0px;
    /* margin-top: ${props => props.estados ? '56px' : props.search && props.hideFilter == false ? '30px' : props.search  ? '16px' : '12px'}; */
    margin-top: 0;
    text-align: start;
  }

  @media (max-width: 435px) {
    max-width: 14rem;
  }

`;

export const ExportButton = styled.div`
  height: 37px;
  width: 37px;
  background-color: #2fbb69;
  display: flex;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 10px;
  color: white;

  img{
    width: 12px;
  }

  &:hover a{
    display:block;
  }

  p{
    white-space: nowrap;
    margin-bottom: 0px;
    cursor: pointer;

    font-weight: 800;
    font-size: 10px;
    line-height: 150%;
    letter-spacing: 0.1rem;
    text-align: center;
    text-transform: uppercase;
  }

  a{
    width: 84px;
    height: 22px;

    display:none;
    position:absolute;
    align-items: center;

    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    
    margin-top: 38px;
    margin-left: -7px;
    
    padding-top: 2px;
    
    color:#FFF !important;
    background-color: ${theme.colors.gray.Cinza_1};
    opacity: 0.9;
    
    border-radius: 5px;

    &:before{
      position: absolute;
      background-color:  ${theme.colors.gray.Cinza_1};
      width: 8px;
      height: 8px;
      top: -4px;
      content: '';
      transform: rotate(45deg);
    }

    &:hover{
      text-decoration: none;
      p{
          display: block;
      }
    }
  }

  @media only screen and (max-width: 900px){
   height: 30px; 
   width: 33px;

  }

`;

export const AddButton = styled.div`
  position: relative;
  height: 37px;
  width: 104px;
  background-color: ${props => props.disabled ? theme.colors.disabled.Fundo_Desabilitado : ' #2fbb69'};
  display: flex;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  margin-left: 24px;
  border-radius: 20px;
  /* box-shadow: 0px 0px 10px -1px black; */
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 10px;
  color: white;

  img{
    width: 12px;
  }

  p{
    color: ${props => props.disabled ? theme.colors.disabled.Desabilitado_Medio : 'white'};
    white-space: nowrap;
    margin-bottom: 0px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};

    font-weight: 800;
    font-size: 10px;
    line-height: 150%;
    letter-spacing: 0.1rem;
    text-align: center;
    text-transform: uppercase;
  }

  @media only screen and (max-width: 900px){
   height: 30px;
  }

  @media only screen and (max-width: 768px){
    display: none;
  }

`;

export const BlockedTooltip = styled.a`
  width: 210px;

  display:none;
  position:absolute;

  font-size: 11px;
  font-weight: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  white-space: normal;

  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 12px;

  padding: 8px 10px;

  color: #FFF;
  background-color: ${theme.colors.gray.Cinza_1};
  opacity: 0.95;
  z-index: 10;

  border-radius: 6px;

  &:before{
    position: absolute;
    background-color: ${theme.colors.gray.Cinza_1};
    width: 8px;
    height: 8px;
    top: -4px;
    left: 50%;
    margin-left: -4px;
    content: '';
    transform: rotate(45deg);
  }
`;

export const BlockedTooltipLink = styled.span`
  display: inline;
  color: ${theme.colors.blue.Azul_link} !important;
  text-decoration: underline;
  cursor: pointer;
`;

export const Desmarc = styled.div`
  width: 100vw;
  height: 104vh;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1;
  background-color: #21262f6e;
`;

export const Search = styled.div`
  margin-top: 0vh;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 900px){
    margin-top: 1vh;
    justify-content: space-between;
    padding-bottom: 0;
  }

  @media only screen and (max-width: 768px){
    margin-top: 0vh;
    width: 100%;
  }

  @media only screen and (max-width: 540px){
    flex-direction: column;
    margin-top:0px;
    padding-bottom: 0px;

    .buttons{
      margin-top: 16px;
    }
  }
`;

export const ExportOptions = styled.div`
  position: absolute;
  background-color: #FFF;
  width: 130px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgb(29 33 41 / 15%);
  padding: 15px;
  margin-left: 8px;
  margin-top: 3px;
  z-index: 2;

  &:before{
    position: absolute;
    background-color:  #fff;
    width: 8px;
    height: 8px;
    top: -4px;
    content: '';
    transform: rotate(45deg);
  }

  .option{
    width: 100%;
    height: 36px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    p{
      font-family: Lato;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #8a92a2;
      cursor: pointer;
      margin-bottom: 0px;
    }

    &:hover{
      background-color: #f3f3f5;
      font-weight: bold;
      cursor: pointer;
    }
  }

`;

export const InputField = styled.input`
  height: 100%;
  width: 80%;
  background: transparent;
  border: none;
  color: black;
  font-size: 10px;
  z-index: 1;
`;

export const HeaderCompendioGratis = styled.div`
    background: url("https://www.agroreceita.com.br/wp-content/uploads/2020/09/símbolo-branco-1.png") center center no-repeat fixed;
    background-color: rgb(41, 46, 56);
    background-size: cover;
    background-position: 0px -20px;
    width: 100vw;
    height: 50vh;

    display: flex;
    flex-direction: column;
    justify-content: start;

    .header{
        width: 90%;
        margin: auto;
        margin-top: 20px;
        margin-bottom: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .logo{
            img{
                width: 150px;
            }
        }

        .links{
            margin-left: 17px;
            a{
                font-family: "Lato", Sans-serif;
                font-size: 10px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 2px;
                margin-left: 60px;
                fill: #fff;
                color: #fff;
                background-color: #fff0;
                border-radius: 50px 50px 50px 50px;
                padding: 10px 12px 10px 12px;
                text-decoration: none;
                text-align: auto;
                transition: all 0.3s;
            }

            a:hover{
                background-color: #FFFFFF2B;
                
            }
        }

        .planos{
            #plans{
                font-family: "Lato", Sans-serif;
                font-size: 10px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 2px;
                fill: #fff;
                color: #fff;
                background-color: #fff0;
                border-style: solid;
                border-width: 2px 2px 2px 2px;
                border-color: #fff;
                border-radius: 50px 50px 50px 50px;
                padding: 14px 14px 14px 14px;
                text-decoration: none;
                transition: all 0.3s;

                &:hover{
                    color: ${theme.colors.gray.Cinza_2};
                    background-color: #fff;
                    border-color: #fff;
                }
            }

            #teste{
                display: inline-block;
                font-family: "Lato", Sans-serif;
                font-size: 11px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 2px;
                background-color: #2FBB69;
                border-style: solid;
                border-color: #2FBB69;
                border-radius: 50px 50px 50px 50px;
                padding: 17px 22px 17px 22px;
                text-decoration: none;
                transition: all 0.3s;
                color: #FFF;

                margin-left: 20px;

                &:hover{
                    transform: scale(1.1);
                }

            }
        }
    }

    .title{
        width: 100%;
        h1{
            color: #FFF;
            text-align: center;
            font-family: "Lato", Sans-serif;
            font-size: 28px;
            font-weight: 700;
            line-height: 34px;
        }
        h2{
            text-align: center;
            color: #BAC1CF;
            font-family: "Lato", Sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 29px;
        }
    }

`;

export const Plans = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  top:  ${props => props.isMobile && '29px'};
  left: ${props => props.isMobile && '60px'};
  transform: ${props => props.isMobile ? 'scale(0.8)' : 'scale(1.0)'};
  width: auto;
  height: 30px;
  font-family: Lato;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgb(223, 228, 235);
  border-radius: 15px;
  background-color: rgb(88, 155, 255);
  padding-top: 9px;
  padding-left: 15px;
  padding-right: 15px;
  margin-right: 16px;
  cursor: pointer;
  z-index: 4;
  transition: all 0.2s ease-out;

  
  &:hover {
    background-color: rgb(88, 155, 255);
    transform: scale(1.06);
    box-shadow: 2px 2px 3px 1px rgba(88, 155, 255, 0.2);
  }

  @media only screen and (max-width: 979px){
    position: absolute;
    left: 56px;
  }

  @media only screen and (max-width: 760px){
    display: none;
  }
`;

export const ManagePlansButton = styled.button`
    all: unset;

    width: auto;
    height: 1.25rem;
    padding: 0.25rem 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 2rem;
    background-color: #E9ECF0;

    p {
        white-space: nowrap;
        cursor: pointer;
    }

    span {
        white-space: nowrap;
        cursor: pointer;
    }

    :hover {
        opacity: 0.7;
    }

    @media (max-width: 470px) {
      width: auto;
    }
`;

export const SubscribeButton = styled.button`
    all: unset;

    width: auto;
    height: 1.25rem;
    padding: 0.25rem 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 2rem;
    background-color: #589BFF;

    > span {
        white-space: nowrap;
        cursor: pointer;

        color: #FFFFFF;
        font-weight: 800;
        font-size: 0.5625rem;
        letter-spacing: 0.1rem;
        line-height: 0.84375rem;
        font-family: "Lato", Sans-serif;
    }

    :hover {
        opacity: 0.7;
    }
`;

export const ContainerTitle = styled.div`
  width: auto;
  height: auto;

  gap: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media (max-width: 768px) {
    align-items: center;

    >div {
        >div:nth-of-type(1){
          margin: 0;
          width: 100%;

          >div>input {
            width: 100%;
          }
        }
      }

      >div>div>div{
        >select{
          width: 125%;
        }
    }
    }

  @media (max-width: 760px) {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 479px) {
    gap: 4px;
  }
`

export const ContainerModal = styled.div`
    width: 100%;
    height: auto;
    max-width: 50rem;

    display: flex;
    align-self: center;
    justify-content: center;
`;

export const LoadingContainer = styled.div`
    width: 50rem;
    min-height: 18rem;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 760) {
        width: 100%;
    }
`

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;